export default "__VITE_ASSET__BL21yWiF__"